import React from 'react';
import Shield from '../../../../assets/images/shield.svg';
import BarStar from '../../../../assets/images/bar-star.svg';
import HomeUser from '../../../../assets/images/home-user.svg';
import type { OnboardingSummary } from '../../../../types/onboarding';
import useOnboardingSummary from '../../../../hooks/useOnboardingSummary';

interface SectionFiveProps {
  section: OnboardingSummary;
}

const SectionFive = ({ section }: SectionFiveProps) => {
  const { mentorshipAreas, idealMentees } = useOnboardingSummary({
    section,
  });

  return (
    <div>
      <div className='font-bold text-body-400 mb-4 flex items-center gap-2 mt-6'>
        <img
          className='w-6 h-6 object-contain'
          src={Shield}
          alt='Primary Goal'
        />
        Primary Goal:
      </div>
      <div className='text-lg mb-6'>Offering mentorship to others</div>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
        <div className='bg-white w-full p-6 rounded-xl'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <img
              className='w-6 h-6 object-contain'
              src={BarStar}
              alt='BarStar'
            />{' '}
            Areas can you mentor in :
          </div>
          <div className='flex flex-wrap gap-4'>
            <p className='text-lg'>{mentorshipAreas}</p>
          </div>
        </div>
        <div className='bg-white w-full p-6 rounded-xl'>
          <div className='font-bold text-secondary-500 mb-4 flex items-center gap-2'>
            <img
              className='w-6 h-6 object-contain'
              src={HomeUser}
              alt='HomeUser'
            />{' '}
            Kind of mentees are you best suited to help
          </div>
          <div className='text-lg'>{idealMentees}</div>
        </div>
      </div>
    </div>
  );
};

export default SectionFive;
